import { Injectable } from '@angular/core';
import {Image} from "../../interfaces/image";
import {Image as BackendImage} from "../../interfaces/backend/image";

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  constructor() { }

  mapRawImageData(rawImageData: any, placeholderType: string = "default"): Image {

    let randomImage = this.getPlaceholderImage();

    if(placeholderType === "person") {
      randomImage = {
        info: {
          caption: 'Avatar',
          copyright: 'Berufsreise',
          alttext: 'Person Avatar'
        },
        huge: {
          width: 1000,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        },
        landscape: {
          width: 100,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        },
        large: {
          width: 700,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        },
        medium: {
          width: 500,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        },
        portrait: {
          width: 400,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        },
        xlarge: {
          width: 1500,
          url: "/assets/img/icons/SUBEJCT=Avatar_Placeholder.svg"
        }

      }
    }


    let parsedImageData: Image = {
      info: {
        caption: rawImageData?.info?.caption ?? '',
        copyright: rawImageData?.info?.copyright ?? '',
        alttext: rawImageData?.info?.alttext ?? ''
      },
      huge: {
        width: rawImageData?.huge?.width ?? randomImage.huge.width,
        url: rawImageData?.huge?.url ?? randomImage.huge.url
      },
      landscape: {
        width: rawImageData?.landscape?.width ?? randomImage.landscape.width,
        url: rawImageData?.landscape?.url ?? randomImage.landscape.url
      },
      large: {
        width: rawImageData?.large?.width ?? randomImage.large.width,
        url: rawImageData?.large?.url ?? randomImage.large.url
      },
      medium: {
        width: rawImageData?.medium?.width ?? randomImage.medium.width,
        url: rawImageData?.medium?.url ?? randomImage.medium.url
      },
      portrait: {
        width: rawImageData?.portrait?.width ?? randomImage.portrait.width,
        url: rawImageData?.portrait?.url ?? randomImage.portrait.url
      },
      xlarge: {
        width: rawImageData?.xlarge?.width ?? randomImage.xlarge.width,
        url: rawImageData?.xlarge?.url ?? randomImage.xlarge.url
      }

    }

    return parsedImageData;

  }

  mapRawImageDataForProvider(rawImageData: any, providerId: number | string): Image {
    if (rawImageData) {
      return this.mapRawImageData(rawImageData);
    }
    return this.getPlaceholderImageForProvider(providerId);
  }

  getPlaceholderImageForProvider(providerId: number | string): Image {
    const placeHolderDir = "/assets/img/placeholders/";
    const index = (Number(providerId) % 40) + 1;
    let rand = "0" + index;
    if (rand.length === 3) {
      rand = rand.substring(1, 3);
    }
    const imageFileName = "BER_final_Placeholder_Arrow_" + rand + ".svg";
    return {
      info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
      medium: {url: placeHolderDir + imageFileName, width: 500},
      portrait: {url: placeHolderDir + imageFileName, width: 400},
      huge: {url: placeHolderDir + imageFileName, width: 1000},
      landscape: {url: placeHolderDir + imageFileName, width: 100},
      large: {url: placeHolderDir + imageFileName, width: 700},
      xlarge: {url: placeHolderDir + imageFileName, width: 1500}
    };
  }

  getPlaceholderImageForProviderBackendImage(providerId: number | string): BackendImage {
    const placeHolderDir = "/assets/img/placeholders/";
    const index = (Number(providerId) % 40) + 1;
    let rand = "0" + index;
    if (rand.length === 3) {
      rand = rand.substring(1, 3);
    }
    const imageFileName = "BER_final_Placeholder_Arrow_" + rand + ".svg";
    const url= placeHolderDir + imageFileName;

    return {
      info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
      medium: {url: url, width: 500},
      portrait: {url: url, width: 400},
      huge: {url: url, width: 1000},
      landscape: {url: url, width: 100},
      large: {url: url, width: 700},
      xlarge: {url: url, width: 1500}
    };
  }

  getPlaceholderImage(): Image {

    const placeHolderDir = "/assets/img/placeholders/";

    let rand = "0" + Math.floor(Math.random() * (40 - 1) + 1);
    if(rand.length === 3) {
      rand = rand.substring(1, 3);
    }

    const imageFileName = "BER_final_Placeholder_Arrow_" + rand + ".svg";

    return {
      huge: {url: placeHolderDir + imageFileName, width: 1000},
      info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
      landscape: {url: placeHolderDir + imageFileName, width: 100},
      large: {url: placeHolderDir + imageFileName, width: 700},
      medium: {url: placeHolderDir + imageFileName, width: 500},
      portrait: {url: placeHolderDir + imageFileName, width: 400},
      xlarge: {url: placeHolderDir + imageFileName, width: 1500}
    }
  }

  /** For dev purposes only */
  getDummyImage(aspectRatio?: "square"|"portrait"|"landscape"|"logo"): Image {
    let url = "";
    switch (aspectRatio) {
      case "square":
        url = "/assets/img/dummy-assets/landscape-image.jpeg";
        break;
      case "portrait":
        url = "/assets/img/dummy-assets/portrait-image.jpg";
        break;
      case "landscape":
        url = "/assets/img/dummy-assets/landscape-image.jpeg";
        break;
      case "logo":
        url = "/assets/img/dummy-assets/logo-image.jpeg";
        break;
    }
    const img: Image = {
      huge: {url: url, width: 1000},
      info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
      landscape: {url: url, width: 100},
      large: {url: url, width: 700},
      medium: {url: url, width: 500},
      portrait: {url: url, width: 400},
      xlarge: {url: url, width: 1500}
    }

    return img;
  }
}
